import BaseComponent from 'foundation/base-component';

export default class upcomingEvents extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.onShowClick = this.onShowClick.bind(this);
        this.init();
    }

    static getRequiredRefs() {
        return ['mainList'];
    }

    init() {
        if (this.refs.trigger) {
            this.addListener(this.refs.trigger, 'click', this.onShowClick);
        }
    }

    onShowClick() {
        if (!Array.isArray(this.refs.hiddenItems)) return;

        this.refs.hiddenItems.forEach((item) => {
            item.classList.add('is-loaded');
            this.refs.mainList.appendChild(item);
        });

        this.removeListeners();
        this.refs.trigger.remove();
    }
}
